'use client';

import { MDSText } from '@midwest/web/base';
import { MDSVStack } from '@midwest/web/stacks';
import styled from 'styled-components';

export const Heading = styled(MDSText.BodyHeavySm)`
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: ${(p) => p.theme.midwestColors.identityBrandPrimaryHeavy};
  font-size: 0.75rem;
`;

export const NavigationLink = styled.a`
  color: ${(p) => p.theme.midwestColors.identityBrandPrimaryDense};
`;

export const NavigationLinkText = styled(MDSText.BodyRegDefault)`
  font-size: 0.875rem;
`;

export const VStack = styled(MDSVStack)`
  gap: 0.75rem;

  & > :nth-child(2) {
    margin-top: -0.5rem;
  }
`;

export const FlexColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4.5rem;
`;
